import { useCallback, useEffect, useMemo, useState } from "react";
import { parseISO, startOfToday } from "date-fns";
import { toast } from "sonner";
import { nextWeekday, toISODate } from "@/lib/studio";
import { api, apiError } from "@/lib/api";

// Selected date, its slot availability and the calendar's disabled days.
export function useAvailability() {
  const [date, setDate] = useState(nextWeekday());
  const [closures, setClosures] = useState([]);
  const [avail, setAvail] = useState(null);
  const iso = toISODate(date);

  useEffect(() => {
    api.get("/closures").then((r) => {
      setClosures(r.data);
      setDate((prev) => nextWeekday(prev, new Set(r.data.map((c) => c.date))));
    }).catch(() => {});
  }, []);

  const reload = useCallback(() => {
    setAvail(null);
    api.get("/availability", { params: { date: iso } })
      .then((r) => setAvail(r.data))
      .catch((e) => toast.error(apiError(e)));
  }, [iso]);

  useEffect(() => {
    reload();
  }, [reload]);

  const disabledDays = useMemo(
    () => [{ dayOfWeek: [0, 6] }, { before: startOfToday() }, ...closures.map((c) => parseISO(c.date))],
    [closures]
  );

  return { date, setDate, iso, avail, reload, disabledDays };
}
